import {
  FETCH_CAMPAIGNS,
  DELETE_CAMPAIGN,
  VALIDATE_AUDIENCE_CSV_FILE,
  FETCH_SHARE_LIST,
  CREATE_CAMPAIGN,
  SEND_EMAIL_INVITATION,
  SET_CURRENT_SHARING_CAMPAIGN_ID,
  CAMPAIGN_SIGN_UP
} from '../constants';

export const fetchCampaigns = () => ({
  type: FETCH_CAMPAIGNS,
});

export const deleteCampaign = (clientId) => ({
  type: DELETE_CAMPAIGN,
  clientId
});

export const validateCsv = (file) => ({
  type: VALIDATE_AUDIENCE_CSV_FILE,
  file
});

export const createCampaign = (payload) => ({
  type: CREATE_CAMPAIGN,
  payload
});

export const setCurrentSharingCampaignId = (campaignId) => ({
  type: SET_CURRENT_SHARING_CAMPAIGN_ID,
  campaignId
});

export const fetchShareList = (campaignId) =>({
  type: FETCH_SHARE_LIST,
  campaignId
});

export const sendEmailInvitation = (payload, campaignId) =>({
  type: SEND_EMAIL_INVITATION,
  payload,
  campaignId
});


export const campaignSignUp = (payload,campaignId,shareId) =>({
  type: CAMPAIGN_SIGN_UP,
  payload,
  campaignId,
  shareId,
});







